import { Link } from 'react-router-dom';

function safeDate(value) {
  if (value == null || value === '') return null;
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
}

function flowName(original) {
  if (!original) return '-';
  const name = original.name ?? '-';
  if (!original.id) return name;
  return <Link to={`/flow-definitions/edit/${original.id}`}>{name}</Link>;
}

function callPhoneNumber(original) {
  return original?.callPhoneNumber ?? '-';
}

function smsPhoneNumber(original) {
  return original?.smsPhoneNumber ?? '-';
}

function createdDateTime(original) {
  const d = safeDate(original?.createdDateTime);
  return d ? d.toLocaleString() : '-';
}

function lastModifiedDateTime(original) {
  const d = safeDate(original?.lastModifiedDateTime);
  return d ? d.toLocaleString() : '-';
}

export {
  flowName,
  callPhoneNumber,
  smsPhoneNumber,
  createdDateTime,
  lastModifiedDateTime,
};
